import { useQuery } from '@apollo/client'
import { useWarehouseContext } from '../../stores/useWarehouseContext'
import { useUserSelectedStore } from '../useUserSelectedStore'
import { GetUpSellingProductsQuery, GetUpSellingProductsQueryVariables } from '@obeta/schema'
import {
  UpSellingDeliveryTime,
  UpSellingProduct,
  UpSellingSupplier,
} from '@obeta/models/lib/schema-models/recommendation'
import { GET_UP_SELLING_PRODUCTS_QUERY } from '../../queries/product/getUpSellingProducts'

type UpSellingProductsReturnType = {
  isLoadingUpSellingProducts: boolean
  upSellingDeliveryTimes: UpSellingDeliveryTime[]
  upSellingProducts: UpSellingProduct[]
  upSellingSuppliers: UpSellingSupplier[]
}

export const useUpSellingProducts = (
  sapId: string,
  options?: {
    maxDeliveryTime: number | undefined
    supplier: string | undefined
  }
): UpSellingProductsReturnType => {
  const { selectedStore } = useUserSelectedStore()
  const { warehouseId } = useWarehouseContext()

  const warehouseIds = [selectedStore?.id, warehouseId].filter(Boolean) as string[]

  const getUpSellingProductsResponse = useQuery<
    GetUpSellingProductsQuery,
    GetUpSellingProductsQueryVariables
  >(GET_UP_SELLING_PRODUCTS_QUERY, {
    variables: {
      maxDeliveryTime: options?.maxDeliveryTime ?? -1,
      sapId,
      supplier: options?.supplier ?? 'ALL',
      warehouseIds,
    },
  })

  const data = getUpSellingProductsResponse?.data

  return {
    isLoadingUpSellingProducts: getUpSellingProductsResponse.loading,
    upSellingDeliveryTimes: data?.getUpSellingProducts?.deliveryTimes ?? [],
    upSellingProducts: data?.getUpSellingProducts?.products ?? [],
    upSellingSuppliers: data?.getUpSellingProducts?.suppliers ?? [],
  }
}
